import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output, OnDestroy, AfterViewInit, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ImageViewService } from './image-view.service';
import { FormControl, Validators } from '@angular/forms';

import { LogService } from '../log-service.service';

import { ToastMessage } from '../toast-message/toast-message.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ConstantsService } from '../constants.service';
import { ImageZoomService } from '../services/image-zoom.service';
import { PopUpMessageComponent } from '../pop-up-message/pop-up-message.component';


@Component({
  selector: 'image-view',
  template: require('./image-view.component.html'),
  providers: [ImageViewService, LogService, ConstantsService]
})
export class ImageViewComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  // rejectReasonFormControl = new FormControl('', [
  //   Validators.maxLength(50)
  // ]);

  @Input() imgUrl: any;
  @Input() imgContent: any;
  @Input() userId: any;
  @Input() imageType: any;
  @Input() view: any;
  @Input() rejectRemarks: any;
  @Input() autoApproved: any;
  @Output() newUrl: EventEmitter<any> = new EventEmitter();
  @Output() rejectDocument: EventEmitter<any> = new EventEmitter();
  @Input() userIdentity = {
    phone: '',
    _id: '',
  };
  @Input() type = '';
  @Input() allowEditing: any;
  @Input() gstRejectReasons: any;

  @Input() isProfileRejected: any;
  @Input() isDlRejected: any;
  @Input() isRCRejected: any;
  @Input() isPanRejected: any;
  @Input() isAadharRejected: any;
  @Input() isImageOptional: boolean;
  @Input() isVerifiedViaOtp: boolean;
  @Input() isAadharInKyc: boolean;
  @Input() hasDocNumber: boolean;
  @Input() docNumber: string;
  @Input() isPermitRejected: any;
  @Input() isFleetOnboarding: any;
  @Input() fleetId: any;
  @Input() isPermitApproved: any;
  @Input() isInsuranceRejected: any;
  @Input() isInsuranceApproved: any;
  @Input() isFitnessRejected: any;
  @Input() isFitnessApproved: any;
  @Input() showVehicleNumberChangeToggle: boolean;
  // When true, uploading DL/RC shows a confirmation nudge (No DL / B2B captains).
  @Input() isNoDlCaptain: boolean;

  public displayUrl: any;
  public ocr: any;
  public input: any;
  public fileName: any;
  public imageToUpload: any;
  public selectedFiles = '';
  public showUpdateButton = false;
  public showImage = false;
  public showRejectReason = false;
  public imageUploaded = false;
  public rejectReason: any;
  public rejectRemarksList = [];
  public dlRejectReasons = [];
  public ppRejectReasons = [];
  public rcRejectReasons = [];
  public roadTaxRejectReasons = [];
  public rcWithoutImageRejectReasons = [];
  public rcWithoutNumberChangeDefaulterRejectReasons = [];
  public panRejectReasons = [];
  public aadharRejectReasons = [];
  public cabRejectionReasons = [];
  public aadhaarVerifiedViaOtpRejectReasons = [];

  public imageTypes: any;
  private S3_URL_REGEX: RegExp;
  constructor(private _imageViewService: ImageViewService,
    private _toastMessage: ToastMessage,
    private spinnerService: Ng4LoadingSpinnerService,
    private _logService: LogService,
    private constantsService: ConstantsService,
    private imageZoomService: ImageZoomService,
    private dialog: MatDialog,
    private el: ElementRef) {
    this.refreshDisplayImage();
    this.imageTypes = this.constantsService.getImageTypes;
    this.S3_URL_REGEX = new RegExp(/(s3-|s3\.)?(.*)\.amazonaws\.com/);
    const docRejectionReasons = constantsService.docRejectionReasons;
    this.dlRejectReasons = docRejectionReasons.dl;
    this.ppRejectReasons = docRejectionReasons.pp;
    this.rcRejectReasons = docRejectionReasons.rc;
    this.roadTaxRejectReasons = docRejectionReasons.roadTax;
    this.cabRejectionReasons = docRejectionReasons.cab;
    this.rcWithoutImageRejectReasons = docRejectionReasons.rcWithoutImage;
    this.rcWithoutNumberChangeDefaulterRejectReasons = docRejectionReasons.rcWithoutNumberChangeDefaulterRejectReasons;
    this.panRejectReasons = docRejectionReasons.pan;
    this.aadharRejectReasons = docRejectionReasons.aadhar;
    this.aadhaarVerifiedViaOtpRejectReasons = docRejectionReasons.aadhaarVerifiedViaOtp;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.imgUrl) {
      this.setImageUrl(changes.imgUrl.currentValue);
    }
    if (changes.rejectRemarks) {
      this.rejectReason = changes.rejectRemarks.currentValue;
    }
    if (this.displayUrl) {
      this.imageUploaded = true;
    }
    if (changes.imageType) {
      this.rejectRemarksList = [];
      if (this.imageTypes.profilePicture === changes.imageType.currentValue) {
        this.rejectRemarksList = this.ppRejectReasons;
      } else if (this.imageTypes.driverLicense === changes.imageType.currentValue) {
        this.rejectRemarksList = this.dlRejectReasons;
      } else if ((this.imageTypes.registrationCard === changes.imageType.currentValue) && !this.isImageOptional) {
        this.rejectRemarksList = this.rcRejectReasons;
      } else if ((this.imageTypes.registrationCard === changes.imageType.currentValue) && this.isImageOptional) {
        this.rejectRemarksList = this.rcWithoutImageRejectReasons;
        this.fetchRcDefaulter(changes.userId.currentValue)
      } else if (this.imageTypes.gstCertificate === changes.imageType.currentValue) {
        this.rejectRemarksList = this.gstRejectReasons;
      } else if (this.imageTypes.panCard === changes.imageType.currentValue) {
        this.rejectRemarksList = this.panRejectReasons;
      } else if (this.imageTypes.aadhar === changes.imageType.currentValue) {
        this.rejectRemarksList = this.aadharRejectReasons;
      } else if (changes.imageType.currentValue === 'roadTax') {
        this.rejectRemarksList = this.roadTaxRejectReasons;
      } else if (this.imageTypes.permit === changes.imageType.currentValue ||
        this.imageTypes.insurance === changes.imageType.currentValue ||
        this.imageTypes.fitness === changes.imageType.currentValue) {
        this.rejectRemarksList = this.cabRejectionReasons;
      }
    }
    if (changes.isVerifiedViaOtp && (this.type === this.imageTypes.aadhar)) {
      this.rejectRemarksList = this.aadhaarVerifiedViaOtpRejectReasons;
    }
    if (changes) {
      if (changes.isDlRejected && changes.isDlRejected.currentValue && !changes.isDlRejected.firstChange) {
        this.clearImageDueToRejection();
      }
      if (changes.isRCRejected && changes.isRCRejected.currentValue && !changes.isRCRejected.firstChange) {
        this.clearImageDueToRejection();
      }
      if (changes.isPanRejected && changes.isPanRejected.currentValue && !changes.isPanRejected.firstChange) {
        this.clearImageDueToRejection();
      }
      if (changes.isAadharRejected && changes.isAadharRejected.currentValue && !changes.isAadharRejected.firstChange) {
        this.clearImageDueToRejection();
      }
      if (changes.isPermitRejected && changes.isPermitRejected.currentValue && !changes.isPermitRejected.firstChange) {
        this.clearImageDueToRejection();
      }
      if (changes.isFitnessRejected && changes.isFitnessRejected.currentValue && !changes.isFitnessRejected.firstChange) {
        this.clearImageDueToRejection();
      }
      if (changes.isInsuranceRejected && changes.isInsuranceRejected.currentValue && !changes.isInsuranceRejected.firstChange) {
        this.clearImageDueToRejection();
      }
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // Capture-phase listener so we can show the confirmation before the upload
    // widget opens the file picker.
    this.el.nativeElement.addEventListener('click', this.uploadNudgeInterceptor, true);
  }

  private isUploadNudgeApplicable(): boolean {
    return !!this.isNoDlCaptain && !!this.allowEditing && (this.type === 'dl' || this.type === 'rc');
  }

  private uploadNudgeInterceptor = (event: Event) => {
    if (!this.isUploadNudgeApplicable()) {
      return;
    }
    const target = event.target as HTMLElement;
    if (!target || !target.closest || !target.closest('image-upload')) {
      return;
    }
    // Let the programmatic file-input click (fired after confirmation) pass through.
    if (target.tagName === 'INPUT') {
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    this.openUploadNudge();
  }

  private openUploadNudge() {
    const isDl = this.type === 'dl';
    const docLabel = isDl ? 'Driving License' : 'RC';
    const notes = isDl
      ? ['Captain has provided a valid DL', 'DL matches captain details']
      : ['Captain has provided a valid RC'];
    const dialogRef = this.dialog.open(PopUpMessageComponent, {
      width: '480px',
      data: {
        options: [],
        title: 'Are you sure you want to continue?',
        message: `${docLabel} is optional for B2B captains.`,
        notesHeading: 'Only continue if:',
        notes,
        footerText: `Please avoid unnecessary or incorrect ${isDl ? 'DL' : 'RC'} uploads.`,
        reason: 'uploadNudge',
        buttonText: 'Yes, Continue',
        cancelText: 'Go Back',
      },
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.triggerFileDialog();
      }
    });
  }

  private triggerFileDialog() {
    const fileInput = this.el.nativeElement.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  onUploadStateChanged(evt) {
    let response;
    if (evt === true) {
      this._imageViewService.deleteTempFiles().subscribe(res => {
        response = res;
      });
    }
  }

  onUploadFinished(evt) {
    this.fileName = evt.file.name + ' has been uploaded.';
    this.imageToUpload = evt.src;
    this.showUpdateButton = true;
    this.imageUploaded = true;
    this.refreshDisplayImage();
  }

  private refreshDisplayImage() {
    // Use ImageZoomService instead of jQuery blowup
    setTimeout(() => {
      this.imageZoomService.initImageZoom('displayImage', {
        width: 400,
        height: 400,
        border: '1px solid black',
        round: false
      });
    }, 100);
  }

  uploadImage() {
    let response;
    this.spinnerService.show();
    if (document.getElementById('BlowupLens')) {
      if (window) {
        this.imageZoomService.hideZoomLens();
      }
    }

    this._imageViewService.updateImage(
      this.imageToUpload, this.imgUrl, this.userId, this.imageType, this.view, this.fileName, this.userIdentity, this.docNumber, this.isImageOptional, this.isFleetOnboarding, this.fleetId).subscribe(res => {
        response = res;
        this.showRejectReason = false;
        if (document.getElementById('BlowupLens')) {
          if (window) {
            this.imageZoomService.showZoomLens();
          }
        }
        this.spinnerService.hide();
        this._imageViewService.deleteTempFiles().subscribe(res => {
        },
          error => {
            this.spinnerService.hide();
            const errorMessage = error.error && error.error.message ? error.error.message : 'Could not upload image';
            this._toastMessage.openSnackBarError(errorMessage);
          });
        // Call setImageUrl to process the URL and set displayUrl internally
        if (response.info && response.info.url) {
          this.setImageUrl(response.info.url);
        }
        if (response.info && response.info.ocr) {
          this.ocr = response.info.ocr;
        }
        const filePath = response.data ? response.data.filePath : '';
        this.newUrl.emit({
          'mode': 'update',
          'url': this.displayUrl,
          'view': this.view,
          filePath: filePath, 
          'ocr': this.ocr,
        });
        this.refreshDisplayImage();
      }, error => {
        this.spinnerService.hide();
        const errorMessage = error.error && error.error.message ? error.error.message : 'Could not upload image';
        this._toastMessage.openSnackBarError(errorMessage);
      });
  }

  addRejectedDocsToQueue() {
    console.log(this.imageType, this.view);
    if (this.rejectReason && this.rejectReason !== this.rejectRemarks) {
      this.rejectDocument.emit({
        imageType: this.imageType, view: this.view, userId: this.userId,
        isAutoApproved: this.autoApproved, data: this.rejectReason, isImageOptional: this.isImageOptional,
        isVerifiedViaOtp: this.isVerifiedViaOtp,
        isAadharInKyc: this.isAadharInKyc
      });

      // Hide the reject reason dropdown after adding to queue
      this.showRejectReason = false;
    } else {
      this._toastMessage.openSnackBarError('Please select the reason for document rejection.');
    }
  }

  // Method to reset UI state after rejection is confirmed
  resetUIAfterRejection() {
    this.showRejectReason = false;
    this.rejectReason = null;
    this.displayUrl = null;
    this.imageUploaded = false;
    this.showUpdateButton = false;
    this.fileName = '';
  }

  deleteImage() {
    this.fileName = '';
    this.imageUploaded = false;
    this.showUpdateButton = false;
    this.displayUrl = null;
    this._toastMessage.openSnackBarSuccess('Image has been deleted');
    this.newUrl.emit({
      'mode': 'delete',
      'url': '',
      'view': this.view
    });
  }

  // Method to clear image due to rejection (without showing success message)
  clearImageDueToRejection() {
    this.fileName = '';
    this.imageUploaded = false;
    this.showUpdateButton = false;
    this.displayUrl = null;
    this.newUrl.emit({
      'mode': 'delete',
      'url': '',
      'view': this.view
    });
  }

  async imageLoad(evt: any) {
    const imageComplete = await evt && evt.path && evt.path[0].complete;
    if (imageComplete) {
      this.spinnerService.hide();
    }
    this.refreshDisplayImage();
  }

  async handeImageLoadError(evt: any) {
    this.spinnerService.hide();
    this._toastMessage.openSnackBarError('couldnt load image');
  }

  setImageUrl(url) {
    if (!url) {
      this.displayUrl = "";
      return;
    }
    this.spinnerService.show();
    if (this.isS3Url(url)) {
      this.spinnerService.hide();
      this.displayUrl = url;
      return;
    }
    const imageUrl = new URL(url)
    this._imageViewService.getPreSignedImageUrl(imageUrl.pathname + imageUrl.search)
      .subscribe(preSignedUrl => {
        this.spinnerService.hide();
        this.displayUrl = preSignedUrl['url'];
      }
        , error => {
          this.spinnerService.hide();
          const errorMessage = error.error && error.error.message ? error.error.message : 'Could not load image';
          this._toastMessage.openSnackBarError(errorMessage);
        });

  }

  isS3Url(url) {
    return this.S3_URL_REGEX.test(url);
  }

  getUploadUrl() {
    switch (this.imageType) {
      case 'profilePicture':
        return '/upload/profile/profilePicture';
      case 'driverLicense':
        return '/upload/dl/dlImage';
      case 'registrationCard':
        return '/upload/rc/rcImage';
      case 'panCard':
        return '/upload/pan/panImage';
      case 'aadhar':
        return '/upload/aadhar/aadharImage';
      case 'permit':
        return '/upload/cab/permit/image';
      case 'fitness':
        return '/upload/cab/fitness/image';
      case 'insurance':
        return '/upload/cab/insurance/image';
      default:
        return '/upload/profile/profilePicture';
    }
  }

  handleImageUpload() {
    // Keyboard-triggered uploads must honour the same nudge as clicks.
    if (this.isUploadNudgeApplicable()) {
      this.openUploadNudge();
      return;
    }
    this.triggerFileDialog();
  }

  fetchRcDefaulter(riderId) {
    let result = this._imageViewService.fetchRcDefaulter(riderId).subscribe(
      response => {
        let rcDefaulter = response['defaulter'];
        let rcDefaulterNumberChanged = response['rcNumberChanged'] ? response['rcNumberChanged'] : false;
        let rcRejected = response['rejected'] ? response['rejected'] : false;
        if (rcDefaulter && !rcDefaulterNumberChanged && !rcRejected) {
          this.rejectRemarksList = this.rcWithoutNumberChangeDefaulterRejectReasons
        }
      },
      error => {
        const errorMessage = error && error.error && error.error.message || 'Could not fetch balance';
        this._toastMessage.openSnackBarError(errorMessage);
      }
    );
  }

  ngOnDestroy() {
    // Clean up zoom lens when component is destroyed
    this.imageZoomService.cleanup();
    this.el.nativeElement.removeEventListener('click', this.uploadNudgeInterceptor, true);
  }
}
